import find from 'lodash/fp/find';

export const findSection = (sectionBegin, sectionEnd) =>
  find(
    item =>
      item.sectionBegin === sectionBegin && item.sectionEnd === sectionEnd,
  );
